module.exports = __webpack_public_path__ + "img/phone.b8f9019.svg";